import { Component, OnInit } from '@angular/core';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import {
  EventMessage,
  EventType,
  AuthenticationResult,
} from '@azure/msal-browser';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  isLoggedIn: boolean = false;
  isAppReady: boolean = false;

  constructor(
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.handleRedirectAndLoginState();
    this.listenToMsalEvents();
  }

  isHomeRoute(): boolean {
    return this.router.url === '/home';
  }

  isStandaloneRoute(): boolean {
    return ['/home', '/aggregator', '/outlook'].includes(this.router.url);
  }

  private handleRedirectAndLoginState() {
    this.msalService.handleRedirectObservable().subscribe({
      next: (result) => {
        if (result) {
          this.msalService.instance.setActiveAccount(result.account);
        }

        const account = this.msalService.instance.getActiveAccount();
        this.isLoggedIn = !!account;
        this.isAppReady = true;


        if (!this.isLoggedIn) {
          this.router.navigate(['/login']);
        } else if (this.router.url === '/' || this.router.url === '/login') {
          this.router.navigate(['/home']);
        }
      },
      error: (err) => {
        this.isAppReady = true;
        this.router.navigate(['/login']);      },
    });
  }

  private listenToMsalEvents() {
    this.msalBroadcastService.msalSubject$.subscribe((event: EventMessage) => {
      if (
        event.eventType === EventType.LOGIN_SUCCESS ||
        event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
      ) {
        const authResult = event.payload as AuthenticationResult;
        this.msalService.instance.setActiveAccount(authResult.account);
        this.isLoggedIn = true;
      }

      if (
        event.eventType === EventType.LOGOUT_SUCCESS ||
        event.eventType === EventType.LOGIN_FAILURE
      ) {
        this.isLoggedIn = false;
      }
    });
  }
}
